export default __webpack_public_path__ + "static/media/register.c57ec894.png";